import React from "react";
import PropTypes from "prop-types";
import onClickOutside from "react-onclickoutside";
import classNames from "classnames";
import "moment/locale/ru";

class Monthpicker extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      viewedYear: parseInt(this.props.year, 10) || new Date().getFullYear(),
      selectedMonth:
        parseInt(this.props.month, 10) ||
        (this.props.isSelectTodayNull ? new Date().getMonth() + 1 : 0),
      selectedYear:
        parseInt(this.props.year, 10) ||
        (this.props.isSelectTodayNull ? new Date().getFullYear() + 1 : 0),
      months: [
        { month: 1, title: "Январь", label: "Янв" },
        { month: 2, title: "Февраль", label: "Фев" },
        { month: 3, title: "Март", label: "Мар" },
        { month: 4, title: "Апрель", label: "Апр" },
        { month: 5, title: "Май", label: "Май" },
        { month: 6, title: "Июнь", label: "Июн" },
        { month: 7, title: "Июль", label: "Июл" },
        { month: 8, title: "Август", label: "Авг" },
        { month: 9, title: "Сентябрь", label: "Сен" },
        { month: 10, title: "Октябрь", label: "Окт" },
        { month: 11, title: "Ноябрь", label: "Ноя" },
        { month: 12, title: "Декабрь", label: "Дек" }
      ],
      today: {
        month: new Date().getMonth() + 1,
        year: new Date().getFullYear()
      }
    };

    this.handleMonthToday = this.handleMonthToday.bind(this);
    this.handleMonthSelect = this.handleMonthSelect.bind(this);
    this.handleYearMinus = this.handleYearMinus.bind(this);
    this.handleYearPlus = this.handleYearPlus.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const { selectedMonth, selectedYear } = this.state;

    if (selectedMonth !== nextProps.month || selectedYear !== nextProps.year) {
      this.setState({
        selectedMonth: nextProps.month,
        selectedYear: nextProps.year
      });
    }
  }

  // eslint-disable-next-line
  handleClickOutside = () => {
    this.props.onChange(
      `${this.state.selectedMonth}.${this.state.selectedYear}`
    );
  };

  prepareWeeks = months => {
    let weekRow = [];
    let weeksAll = [];

    months.forEach((item, index) => {
      const dayPickerClasses = classNames(
        "DayPicker-Day-Month",
        {
          "DayPicker-Day-Month--selected":
            this.state.selectedYear === this.state.viewedYear &&
            (this.state.selectedMonth === item.month ||
              this.state.selectedMonth === index + 1),
          "DayPicker-Day-Month--outside":
            (this.state.viewedYear === this.props.minYear &&
              (this.props.minMonth > item.month ||
                this.props.minMonth > index + 1)) ||
            (this.state.viewedYear === this.props.maxYear &&
              (this.props.maxMonth < item.month ||
                this.props.maxMonth < index + 1))
        },
        this.props.dayPickerClassName
      );

      let onClickSelectMonth;
      if (
        (this.state.viewedYear === this.props.minYear &&
          this.props.minMonth <= item.month) ||
        (this.state.viewedYear === this.props.maxYear &&
          this.props.maxMonth >= item.month)
      ) {
        onClickSelectMonth = () => {
          console.log(
            "onClickSelectMonth:",
            this.state.viewedYear,
            this.props.minYear,
            this.props.minMonth,
            item.month,
            this.props.maxMonth,
            item.month
          );
        };
      } else {
        onClickSelectMonth = this.handleMonthSelect;
      }

      weekRow.push(
        <div
          key={`month-${item.month || index + 1}`}
          className={dayPickerClasses}
          tabIndex={-1}
          role="gridcell"
          aria-label={item.title || item}
          aria-disabled="false"
          aria-selected="false"
          data-month={item.month}
          data-index={index}
          data-title={item.title}
          onClick={onClickSelectMonth}
        >
          {item.label || item}
        </div>
      );

      if ((item.month && item.month % 4 === 0) || (index + 1) % 4 === 0) {
        weeksAll.push(
          <div key={`week-${index + 1}`} className="DayPicker-Week" role="row">
            {weekRow}
          </div>
        );
        weekRow = [];
      }
    });

    return weeksAll;
  };

  handleMonthToday = event => {
    event.preventDefault();

    const month = new Date().getMonth() + 1;
    const year = new Date().getFullYear();

    this.setState({
      viewedYear: year,
      selectedMonth: month,
      selectedYear: year
    });

    this.props.onChange(`${month < 10 ? "0" : ""}${month}.${year}`);
  };

  handleYearMinus = event => {
    event.preventDefault();

    const viewedYear = parseInt(this.state.viewedYear, 10);

    this.setState({
      viewedYear: viewedYear - 1
    });
  };

  handleYearPlus = event => {
    event.preventDefault();

    const viewedYear = parseInt(this.state.viewedYear, 10);

    this.setState({
      viewedYear: viewedYear + 1
    });
  };

  handleMonthSelect = event => {
    event.preventDefault();

    const index = event.target.getAttribute("data-index");
    const month = event.target.getAttribute("data-month");
    const selectedMonth = parseInt(month || index + 1, 10);
    const selectedYear = this.state.viewedYear;

    console.log("handleMonthSelect:", selectedMonth, selectedYear);

    this.setState({
      selectedMonth,
      selectedYear
    });

    this.props.onChange(
      `${selectedMonth < 10 ? "0" : ""}${selectedMonth}.${selectedYear}`
    );
  };

  render() {
    if (this.props.isShow) {
      return (
        <div className="datepicker-overlay-wrapper">
          <div
            className={`datepicker-overlay ${this.props.datepickerOverlayClassName}`}
          >
            <div className="DayPicker">
              <div className="DayPicker-wrapper">
                <div className="DayPicker-NavBar">
                  {this.state.viewedYear <= this.state.minYear ? (
                    <span
                      className="DayPicker-NavButton DayPicker-NavButton--prev DayPicker-NavButton--interactionDisabled"
                      role="button"
                      onClick={this.handleYearMinus}
                    />
                  ) : (
                    <span
                      className="DayPicker-NavButton DayPicker-NavButton--prev"
                      role="button"
                      onClick={this.handleYearMinus}
                    />
                  )}

                  {this.state.viewedYear >= this.state.maxYear ? (
                    <span
                      className="DayPicker-NavButton DayPicker-NavButton--next DayPicker-NavButton--interactionDisabled"
                      role="button"
                    />
                  ) : (
                    <span
                      className="DayPicker-NavButton DayPicker-NavButton--next"
                      role="button"
                      onClick={this.handleYearPlus}
                    />
                  )}
                </div>
                <div className="DayPicker-Months">
                  <div className="DayPicker-Month" role="grid">
                    <div className="DayPicker-Caption" role="heading">
                      <div>{this.state.viewedYear}</div>
                    </div>
                    <div className="DayPicker-Body" role="rowgroup">
                      {this.prepareWeeks(this.state.months)}
                    </div>
                  </div>
                </div>
                <div className="DayPicker-Footer">
                  {(this.state.today.year === this.props.minYear &&
                    this.props.minMonth <= this.state.today.month) ||
                  (this.state.today.year === this.props.maxYear &&
                    this.props.maxMonth >= this.state.today.month) ? (
                    <button
                      className="DayPicker-TodayButton"
                      type="button"
                      disabled={true}
                    >
                      Сегодня
                    </button>
                  ) : (
                    <button
                      className="DayPicker-TodayButton"
                      type="button"
                      onClick={this.handleMonthToday}
                    >
                      Сегодня
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    } else {
      return null;
    }
  }
}

Monthpicker.defaultProps = {
  minMonth: 0,
  maxMonth: 0,
  minYear: 0,
  maxYear: 0,
  month: 0,
  year: 0,
  isShow: false,
  isSelectTodayNull: false,
  onChange: () => {
    return null;
  },
  datepickerOverlayClassName: "",
  dayPickerClassName: ""
};

Monthpicker.propTypes = {
  minMonth: PropTypes.number,
  maxMonth: PropTypes.number,
  minYear: PropTypes.number,
  maxYear: PropTypes.number,
  month: PropTypes.number,
  year: PropTypes.number,
  isShow: PropTypes.bool,
  isSelectTodayNull: PropTypes.bool,
  onChange: PropTypes.func,
  datepickerOverlayClassName: PropTypes.string,
  dayPickerClassName: PropTypes.string
};

export default onClickOutside(Monthpicker);
